import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Button, Tabs, Tab } from 'react-bootstrap';

import { PAGES, trackPageView } from '../../../util/mixpanel';

import Header from '../../../components/Header/Header';
import ImageSize from '../../../components/ImageSize/ImageSize';

import arrowUpIcon from '../../../assets/img/arrow_upward.svg';

// Import Style
import './../Terms.scss';

class Terms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: 'terms'
    };
  }

  agree = () => {
    global.window &&
      window.location &&
      window.location.replace(
        `/api/integrations/accept?user=${this.props.location.query.user}&a=true${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${
          this.props.location.query.setup ? `&setup=${this.props.location.query.setup}` : ''
        }${
          this.props.location.query.host ? `&host=${this.props.location.query.host}` : ''
        }`
      );
  };

  decline = () => {
    global.window &&
      window.location &&
      window.location.replace(`/api/integrations/decline?user=${this.props.location.query.user}`);
  };

  render() {
    trackPageView(PAGES.TERMS);

    return (
      <div className="terms_page">
        <Header title="" showHome={false} />
        
        <Helmet>
          <title>{pageTitle('Terms')}</title>
        </Helmet>
        <div className="terms_content">
          <div className="terms_tabs">

          
          <Tabs
            defaultActiveKey={this.state.key}
            onSelect={key => this.setState({ key })}
            id="terms-and-services">
            <Tab eventKey='terms' title="Terms of Service">
              <div className="terms_scroll_content">
                <a name="terms-of-service"></a>
                <h1>TERMS OF SERVICE</h1>
                <div>
                  <h2>I. GENERAL PROVISIONS. ACCEPTANCE OF TERMS</h2>
                  <p>
                    <span>1.</span> The following Terms of Service together with any other operating rules, policies
                    and procedures that may be published on Nave's website{' '}
                    <a target="_blank" href="https://getnave.com">
                      https://getnave.com
                    </a>{' '}
                    ("the Website") including without limit Nave's{' '}
                    <a target="_blank" href="https://getnave.com/data-processing-agreement">
                      Data Processing Agreement{' '}
                    </a>
                    and{' '}
                    <a href="#" onClick={() => this.setState({ key: 'privacy' })}>
                      Privacy Policy
                    </a>{' '}
                    (collectively hereinafter referred as the "Agreement") govern all use of the Website and Nave's
                    services and/or mobile applications ("the Services"), including Nave's{' '}
                    <i>Dashboards for Kanban Teams</i> ("the Product").
                  </p>
                  <p>
                    <span>2.</span> Please read these Terms of Service carefully before accessing or using the
                    Product or any of the Services. By accessing or using any part of the Product or the Services
                    you agree to become bound by these Terms of Service. If you do not agree to these Terms of
                    Service in full and without modification, then you may not access or use the Product or the
                    Services.
                  </p>
                  <p>
                    <span>3.</span> The Product and the Services are owned and operated by Nave Ltd. - a company
                    duly registered and existing under the laws of the Republic of Bulgaria, with company number
                    202979859 and seat and registered address in Bulgaria, 1336 Sofia, Lyulin residential district,
                    bl. 384, entr. A, floor 7, ap. 20 ("Nave").
                  </p>
                  <p>
                    <span>4.</span> The Agreement shall be applicable to the use of Product or other Services on a
                    trial basis as well. The Agreement shall not be applicable to the use of products and services
                    of third parties (such as Trello, Asana, Jira, Azure DevOps, ZenHub), which use is settled
                    through separate terms of use, agreements, policies, etc.
                  </p>
                  <p>
                    <span>5.</span> By using the Product and Services, you acknowledge and agree that the Website
                    and any downloadable software associated with the Product or Services are protected by copyright
                    laws and international copyright treaties, as well as other intellectual property laws and
                    treaties.
                  </p>
                </div>

                <div>
                  <h2>II. DEFINITIONS</h2>
                  <p>
                    <span>6.</span> When implementing and interpreting the Agreement, the terms used in it shall
                    have the following meanings:
                  </p>
                  <p className="second">
                    <span>a.</span> "Platform" referred to herein means an online collaboration tool for management
                    and organization of projects onto boards (for example, Trello, Asana, Jira, Azure DevOps,
                    ZenHub, etc.), which could be synchronized with the Product by the use of the functionalities
                    available in the Product.
                  </p>
                  <p className="second">
                    <span>b.</span> "User Content" or "Content" means information, data, text, photographs, videos,
                    audio clips, written posts and comments, software, scripts, graphics, and interactive features
                    generated, provided, or otherwise made accessible by the User on or through the Services.
                  </p>
                  <p className="second">
                    <span>c.</span> "User/Account Owner” refers to any individual or legal entity who have signed-up
                    for a free trial or a paid subscription plan of the Product and created a Nave Account. In case
                    where in the subscription form is specified the name of a legal entity, it shall be considered
                    that this legal entity is the Account Owner (the User) and the individual who is registering a
                    Nave Account is duly authorized to represent that legal entity and to agree to the Terms of
                    Service and subscribe to Nave’s Services on behalf of such entity.
                  </p>
                  <p className="second">
                    <span>d.</span> “Sub-user/s” refers to any individual who is authorized with an invitation by
                    the Account Owner to act and use the Account on behalf of the Account Owner. Based on the
                    settings chosen by the Account Owner for each Sub-user, the Sub-user may be able to: - 1) manage
                    billing (perform the initial subscription of an Account, change the subscription plan, change
                    billing details and payment methods); 2) manage dashboards;
                    <br />
                    modify and manage the User Content in the Account, 3) create dashboards (contribute e.g. to sync
                    and make accessible the Account Content from different Platforms) and/or 4) manage users (to
                    authorize other sub-Users to perform all of the enlisted activities on behalf of the Account
                    Owner, including to grant access to the Content in the Account to other individuals), as well as
                    to restrict authorizations for other Sub-Users and the Account Owner and to remove Sub-Users
                    from the Account. Each Sub-User has full access to the entire Content in the Account. Any action
                    performed by the Sub-User in the Account shall be considered action performed on behalf of the
                    Account Owner. All Sub-Users shall be considered to access the Account and the User Content and
                    use the Services only on behalf of the Account Owner.
                  </p>
                  <p className="second">
                    <span>e.</span> "Nave Account" or "Account" means an account in the Product which the User
                    creates when signing up for the Product. By creating a Nave Account, the User authorizes Nave to
                    sync the Account in the Product with the User’s Platform data as per the settings the User
                    chooses in the Product.
                  </p>

                  <p className="second">
                    <span>f.</span> "Platform User" means any person who has been authorized to access boards which
                    are synced with the Product in the User's Account and use available Platform features thereon
                    (such as assigning cards, posting comments, etc.).
                  </p>

                  <p className="second">
                    <span>g.</span> "Malicious activities" are actions or inactions that violate the Internet ethics
                    or inflict damages on persons who are connected to the Internet or associated networks; the
                    sending of unwanted messages (unsolicited commercial messages, SPAM, JUNK MAIL); channel
                    overflow (FLOOD); getting access to resources based on other people's rights and passwords; the
                    use of information systems' shortcomings for personal benefit or for the obtaining of
                    information (HACK); identity change; the performance of actions that could be qualified as
                    industrial espionage or sabotage; the damaging or destruction of information systems or
                    information databases (CRACK); the sending of "Trojan horses" or causing the installation of
                    viruses or remote control systems; disturbing the normal work of other Internet and associated
                    networks' users; the performance of any acts that could be qualified by the Bulgarian or any
                    other legislation as criminal or administrative infringements.
                  </p>
                  <p className="second">
                    <span>h.</span> "Accidental event" is an unforeseeable overwhelming event or action
                    unpredictable at the time of contract's signing, which is not due to the guilty behavior of Nave
                    and which makes the provision of the Services impossible.
                  </p>
                </div>

                <div>
                  <h2>III. SUBSCRIPTION FOR AND USE OF THE PRODUCT</h2>
                  <p>
                    <span>7.</span> Nave's Product – <i>Dashboards for Kanban Teams</i>, syncs (integrates) with the
                    Platforms' API and generates visualizations through the creation of cumulative flow diagrams,
                    cycle time scatterplots, throughput histograms and others associated with the Platforms’ boards
                    by accessing, syncing and displaying information available within the respective Platform’s
                    account as well as information related to the use of the Platform’s features. The setup and use
                    of the Product requires the existence of a valid Platform account and Platform login credentials
                    and depends on the Platform settings of the respective Platform account. The Product also includes an optional AI-powered analytics feature that generates workflow insights using third-party AI service providers. Details on data processing for this feature are provided in the Privacy Policy and the Data Processing Agreement.
                  </p>
                  <p>
                    <span>8.</span> In order for the User to sign-up and get access to the Product, the User shall
                    create a Nave Account. At the time of the creation of the Account, the User shall accept the
                    present Terms of Service. By signing up for using the Product and accepting these Terms of
                    Service, the User is deemed to enter into a contractual relation with Nave.
                  </p>
                  <p>
                    <span>9.</span> Sub-users can get access to the Product only upon accepting the present Terms of
                    Service. By accepting these Terms of Service, the Sub-user undertakes to observe them, while
                    using the Product and shall be considered contractually bound to observe the mandatory rules for
                    the use of the Product specified in these Terms of Service.
                  </p>
                  <p>
                    <span>10.</span> To use the Product, the User shall authenticate to a Platform using their
                    credentials and provide, through the Platform, an authorization to Nave to access certain types
                    of data within their Platform account. The categories of these data are indicated in the
                    authorization page. In case of a successful authentication, the Platform sends an authorization
                    token which shall allow Nave to sync the Nave Account of the User with the respective Platform
                    account/s and data of the User through the Product. Тhe Product could also be used without
                    synchronization with a Platform, in which case the process described above does not apply and
                    the User uploads the Content manually to start using the Product.
                  </p>
                  <p>
                    <span>11.</span> After sign-up and for the whole period of the subscription, Nave could send
                    product-related announcements and information to the emails associated with the User's Account.
                    These announcements include on-boarding communications with respect to the sign-up to the
                    Product, email notifications for certain events related to the sign-up and use of the Product,
                    incl. good practices on how to optimize the use of the Product.
                  </p>
                  <p>
                    <span>12.</span> Subject to these Terms of Service, upon subscription for use of the Product,
                    Nave shall provide the User with a non-exclusive, non-transferable right to use the Product
                    solely for their internal business operations.
                  </p>
                  <p>
                    <span>13.</span> In case of any unauthorized uses of the Account or any other breaches of
                    security the User must immediately notify Nave. Nave will not be liable for any acts or
                    omissions by the User, including any damages of any kind incurred as a result of such acts or
                    omissions.
                  </p>
                  <p>
                    <span>14.</span> The User can access the Product either through the Website or through a
                    generated URL for direct access to the Product graphs/visualizations.
                  </p>
                  <p>
                    <span>15.</span> The number of the Platform Users as well as their activities within the User's
                    Platform boards (moving cards, assigning cards, posting comments, etc.) depend on the User's
                    Platform board settings.
                  </p>
                  <p>
                    <span>16.</span> While using the Product the User shall not access, store, distribute or
                    transmit any viruses, materials or content which:
                  </p>
                  <p className="second">
                    <span>16.1.</span> are unlawful, harmful, threatening, defamatory, obscene, infringing,
                    harassing or racially or ethnically offensive; facilitate illegal activity;
                  </p>
                  <p className="second">
                    <span>16.2.</span> depict sexually explicit images;
                  </p>
                  <p className="second">
                    <span>16.3.</span> promote unlawful violence;
                  </p>
                  <p className="second">
                    <span>16.4.</span> are discriminatory based on race, gender, color, religious belief, sexual
                    orientation, disability; or
                  </p>
                  <p className="second">
                    <span>16.5.</span> are otherwise illegal or cause damage or injury to any person or property.
                  </p>
                  <p>
                    <span>17.</span> The User may sync (e.g. access, integrate/synchronize and display) with the
                    Product only Platform accounts which the User possesses and/or is entitled to use in such a
                    manner.
                  </p>
                  <p>
                    <span>18.</span> In case of a breach to the provisions stipulated under item 17 above, Nave
                    reserves the right, without liability or prejudice to its other rights, to disable the
                    respective User's access to the Product.
                  </p>
                  <p>
                    <span>19.</span> Nave cannot and will not be held liable for any loss or damage arising from a
                    failure of the User to comply with the present section and the Agreement as a whole.
                  </p>
                </div>

                <div>
                  <h2>IV. PAID SUBSCRIPTION FOR THE PRODUCT. METHOD OF PAYMENT</h2>
                  <p>
                    <span>20.</span> Upon signing up, Nave shall provide the User with a 14-day free trial period. Nave has the right to extend the free trial up to 3 months. During the trial period, the User has the right to discontinue at User’s own discretion the use
                    of the Product without owing any compensation or penalty and without stating any reason.
                  </p>
                  <p>
                    <span>21.</span> Upon expiration of the free trial period, the User shall be notified and
                    provided the opportunity to continue to use the Product for a remuneration. The User may also
                    subscribe for a paid use of the Product before the expiration of the free trial period.
                  </p>
                  <p>
                    <span>22.</span> While subscribing for a paid use of the Product, the User shall select one of the available plans as well as a billing cycle
                    (e.g. monthly, quarterly, annually, or other custom terms as offered by Nave).
                    Information regarding the plans has been made available on the Website, at{' '}
                    <a href="https://getnave.com/pricing" target="_blank">
                      https://getnave.com/pricing
                    </a>.
                  </p>
                  <p className="second">
                    <span>22 a.</span> Subscription fees are billed in advance based on the billing cycle selected by the User. Pricing is fixed for the duration of the active subscription term. For subscriptions longer than one month, any changes to pricing will be communicated to the User at least 30 calendar days prior to the renewal date. For monthly subscriptions, pricing may be updated at any time and will apply at the start of the next billing cycle following notification.
                  </p>
                  <p>
                    <span>23.</span> Irrespective of the selected plan, the total amount due by the User for the use
                    of the Product under the selected plan shall be based on the number of Platform boards that are
                    synced with the Product in the User's Account. Once the number of allowed boards has been
                    reached, Nave will notify the User offering an option to upgrade.
                  </p>
                  <p>
                    <span>24.</span> If a User transfers the subscription for a paid use of the Product to another plan, Nave will balance the billing in the following ways. 
                    An upgrade in plans will be effective immediately and the User shall be charged based on the remainder of the billing cycle. 
                    A downgrade in plans shall take effect at the end of the current billing period and the new amount shall be applied henceforth. 
                    Where additional boards are added to an existing subscription during an active billing cycle, the per-board price for the additional boards shall be 10% higher than the per-board price at the time of the original subscription. The additional boards shall be billed at the full billing cycle rate regardless of when they are added.
                  </p>
                  <p className="second">
                    <span>24 a.</span> Where additional boards are added to an existing subscription during an active
                    billing cycle, the per-board price for the additional boards shall be 10% higher than the
                    per-board price applicable at the time of the original subscription or most recent renewal. The
                    additional boards shall be billed at the full annual per-board rate regardless of when during the
                    billing cycle they are added.
                  </p>
                  <p>
                    <span>25.</span> Payments shall be charged on a pre-pay basis at the moment of the purchase
                    (subscription) and will provide the User with the right to use the Product for the period and
                    amount of selected Platform boards indicated at the time of subscription. In cases where the subscription fees are paid via a wire transfer, the fees shall be paid within the term specified in the invoice.
                  </p>
                  <p>
                    <span>26.</span> All payments for the use of the Product will be charged from the payment
                    card/PayPal details provided by the User at the time of the initial subscription, except in cases where the due fees are payable via a wire transfer. It is the
                    User's responsibility to ensure that all bank card/PayPal details are accurate and kept up to
                    date.
                  </p>
                  <p>
                    <span>27.</span> In cases where the receiving due payment is rendered impossible through no fault
                    of Nave, Nave reserves the right to disable the User's access to a portion of or all features of
                    the Product until payment has been received. The same applies in cases where a due fee is not paid within the term specified in the invoice for its payment.
                  </p>
                  <p>
                    <span>28.</span> All amounts and fees payable under the present Terms of Service shall be
                    payable in US dollars or another currency as Nave shall stipulate. Amounts and fees paid under a
                    monthly subscription plan are non-cancellable and non-refundable. Amounts and fees paid under an
                    annual subscription plan are refundable, no questions asked, provided that the request for a
                    refund is made by the Account Owner, or the Account Admin in case the Account Owner is a legal
                    entity, within 30 calendar days following the renewal date.
                  </p>
                  <p>
                    <span>29.</span> The User may unsubscribe and discontinue the paid use of the Product by turning
                    off the automatic renewal option within the Account. In such case Nave will suspend the Account
                    after the expiration of the respective billing period and will permanently delete all
                    information and data contained in the Account within 3 (three) months. During the 3-month period
                    between the suspension of the Account and the permanent deletion of the Account and the Content
                    therein, the User may subscribe again for a paid use of the Product which will allow the User to
                    recover the Content in the Account in relation to the use of the Product before the suspension
                    of the Account.
                  </p>
                </div>

                <div>
                  <h2>V. USER'S RIGHTS AND OBLIGATIONS</h2>
                  <p>
                    <span>30.</span> Each User shall have the right to withdraw, without owing any compensation or
                    penalty and without stating the reason for such decision, of the remotely concluded Agreement
                    within a 14-day period as from the date of the sign-up for the free trial period in accordance
                    with item 20 above.
                  </p>
                  <p>
                    <span>31.</span> The User shall have the right to access and use the Product and Services
                    provided that the User complies with the terms and conditions of the Agreement and provided that
                    the User conforms with the specific requirements established by Nave for the use of the
                    respective Product or Services.
                  </p>
                  <p>
                    <span>32.</span> The User and all Sub-users who are acting on the User’s behalf shall strictly
                    abide by the terms set forth in the Agreement, including the present Terms of Service, the Data
                    Processing Agreement and Nave Privacy Policy.
                  </p>
                  <p>
                    <span>33.</span> The User shall ensure that all Sub-users abide by the terms set forth in the
                    Agreement, including the present Terms of Service, the Data Processing Agreement and Nave
                    Privacy Policy.
                  </p>
                  <p>
                    <span>34.</span> The User shall secure the technical equipment, software, internet access and
                    access to mobile phone service and mobile data transfer which the User needs to use the Product
                    and Services.
                  </p>
                  <p>
                    <span>35.</span> When using the Product and the Services, the User shall commit and shall be
                    responsible for all Sub-users, associated with the User’s Account:
                  </p>
                  <p className="second">
                    <span>35.1.</span> to observe the Agreement and the applicable legislation;
                  </p>
                  <p className="second">
                    <span>35.2.</span> not to infringe on other persons' proprietary or non-proprietary rights,
                    including intellectual property rights;
                  </p>
                  <p className="second">
                    <span>35.3.</span> to promptly inform Nave on any case of committed or established violation in
                    the use of the Product and Services;
                  </p>
                  <p className="second">
                    <span>35.4.</span> to provide, upon subscription and while using the Product and Services, true,
                    accurate and complete information as required by Nave, the Agreement and the applicable
                    legislation;
                  </p>
                  <p className="second">
                    <span>35.5.</span> to use the Product and Services only for their intended purposes as described
                    in these Terms of Service and within the Website;
                  </p>
                  <p className="second">
                    <span>35.6.</span> not to perform any malicious actions.
                  </p>
                </div>

                <div>
                  <h2>VI. NAVE'S RIGHTS AND OBLIGATIONS</h2>
                  <p>
                    <span>36.</span> Nave shall have the right at its own discretion and without giving any warning,
                    to suspend or temporary restrict User's access to the Product or Services, provided it is in
                    possession of data or has doubts that the User is using the Product or Services in violation of
                    the applicable legislation or the Agreement.
                  </p>
                  <p>
                    <span>37.</span> Nave is not obliged, nor has the objective possibility to control the way
                    and/or the purposes for which the User uses the Product and Services. Furthermore, Nave is not
                    being required to seek facts and circumstances indicating the performance of any illegal
                    activity.
                  </p>
                  <p>
                    <span>38.</span> Should the User fail on any of the User’s duties referred to in item 36
                    hereinabove, Nave shall be entitled to suspend or forthwith cease, without advance notice, the
                    provision of the Product and Services, or unilaterally terminate the Agreement with immediate
                    effect and/or if illegal activities are suspected, to notify the competent authorities.
                  </p>
                  <p>
                    <span>39.</span> Nave shall commit itself to provide the User with Product and Services in
                    compliance with the terms and conditions of the Agreement and the applicable legislation.
                  </p>
                </div>

                <div>
                  <h2>VII. RESPONSIBILITY</h2>
                  <p>
                    <span>40.</span> The User shall be responsible for the performance of the duties specified in
                    section V hereinabove.
                  </p>
                  <p>
                    <span>41.</span> The User shall be solely responsible for the use of the User’s Account,
                    including for any use of the said Account by Sub-users associated with this Account and any
                    other third party.
                  </p>
                  <p>
                    <span>42.</span> The User shall indemnify Nave for all the damages and lost profits incurred by
                    it, including all paid fines, lawyer's remunerations, and other expenses resulting from claims
                    raised by third parties or compensations paid to third parties in relation to User's violation
                    of User’s contractual duties and any document that constitutes an integral part of the
                    Agreement. The User shall also cover all the damages caused by an infringement of User’s duties
                    under the applicable legislation.
                  </p>
                  <p>
                    <span>43.</span> The User declares and agrees to use the Product and Services entirely at User’s
                    own risk and responsibility and further declares and agrees that Nave shall not be held liable
                    for eventual damages inflicted on the User during the said use, except when the said damages
                    have been deliberately caused by Nave or have resulted from gross negligence on its part, unless
                    explicitly specified otherwise by the law.
                  </p>
                  <p>
                    <span>44.</span> Nave shall not be liable to the User for damages occurring as a result of the
                    User providing untrue, incomplete or inaccurate data.
                  </p>
                  <p>
                    <span>45.</span> Nave shall not be held responsible and liable for damages and/or lost profits
                    caused:
                  </p>
                  <p className="second">
                    <span>45.1.</span> due to the loss of data resulting from materials and resources which have
                    been sought, uploaded or used in any way through the Product and/or the Services;
                  </p>
                  <p className="second">
                    <span>45.2.</span> by User's untimely request or failure to send a request for the suspension /
                    termination of the Product and/or Services;
                  </p>
                  <p className="second">
                    <span>45.3.</span> by User's failure to perform on User’s contractual duties and any other
                    document that is an integral part of the Agreement, nor shall Nave be held liable for any
                    damages caused by User's non-performance on User’s duties under the applicable legislation.
                  </p>
                  <p>
                    <span>46.</span> Nave shall not be held responsible for the availability and quality of the
                    services provided to the User by third parties, including, but not only, Trello, Asana, Jira,
                    Azure DevOps, ZenHub (e.g. Platform service providers). Since the actions performed by these
                    third parties are not controlled by Nave, Nave will not bear any responsibility for the unlawful
                    nature of their activity, nor shall Nave be held liable for the emergence, guaranteeing,
                    alteration or termination of any assumed obligations and commitments related to any goods or
                    services offered by such third parties, nor shall Nave be held responsible for any damages and
                    lost profits suffered as a result of these relationships.
                  </p>
                  <p>
                    <span>47.</span> Nave shall not be held responsible for the non-delivery of the Product or
                    Services upon the occurrence of circumstances that are beyond its control, i.e. cases of Force
                    Majeure, accidental events, problems with the Internet global network, the electronic
                    communication systems and the provision of services beyond the control of Nave, nor shall it be
                    held liable in the event of third parties gaining unauthorized access to the User's Account.
                  </p>
                </div>

                <div>
                  <h2>VIII. PERSONAL DATA</h2>
                  <p>
                    <span>48.</span> Matters related to personal data processing in relation to the provision of the
                    Product and the Services are regulated by the Data Processing Agreement and the Privacy Policy,
                    which are an integral part of the Agreement.
                  </p>
                </div>

                <div>
                  <h2>IX. AGREEMENT'S AMENDMENT AND TERMINATION</h2>
                  <p>
                    <span>49.</span> Nave shall have the right to unilaterally amend the Agreement's terms and
                    conditions and shall notify the User on each amendment, as required by the law.
                  </p>
                  <p>
                    <span>50.</span> In the event the User does not agree with the amendments, the User may renounce
                    the Agreement without stating a reason and without owing any compensation or default. In this
                    particular case, the Agreement shall be automatically terminated upon Nave's receipt of the
                    User's notice referred to in item 52 herein below, unless Nave has explicitly indicated a
                    possibility for the continuous use of the Product or Services under the terms and conditions
                    that have been valid prior to the said amendment. This rule shall not be applied in those cases
                    where the amendment to the contractual terms and conditions is the result of changes in
                    mandatory rules of the applicable legislation or an order or instruction issued by a competent
                    authority.
                  </p>
                  <p>
                    <span>51.</span> The User may exercise the right under item 50 hereinabove by making a statement
                    to Nave within one month after the date of the notification referred to in item 49 hereinabove.
                    Should the User fail, within the aforementioned period, to give notice of disagreement with the
                    amendments, these shall be considered as binding on User.
                  </p>
                  <p>
                    <span>52.</span> The Agreement shall be terminated:
                  </p>
                  <p className="second">
                    <span>52.1.</span> upon Nave ceasing its activity; or
                  </p>
                  <p className="second">
                    <span>52.2.</span> upon Nave being liquidated; or
                  </p>
                  <p className="second">
                    <span>52.3.</span> at the parties' mutual consent; or
                  </p>
                  <p className="second">
                    <span>52.4.</span> in any other case as provided for by the law.
                  </p>
                </div>

                <div>
                  <h2>X. INTELLECTUAL PROPERTY RIGHTS</h2>
                  <p>
                    <span>53.</span> The intellectual property rights on the software applications and products,
                    databases and other materials and resources related to the offering of the Product or Services
                    are protected under the Copyright and Related Rights Act. These rights belong to Nave or to a
                    designated person that have granted the right to use to Nave, and they cannot be used in
                    violation of the applicable legislation.
                  </p>
                  <p className="second">
                    <span>53 a.</span> The User grants Nave a non-exclusive, royalty-free, worldwide right,
                    for the duration of the Agreement, to use the User's company name and logo to identify
                    the User as a customer of Nave on Nave's website, in customer lists, and in presentations
                    and other marketing materials, in accordance with any trademark usage guidelines the User
                    provides in writing. Nave shall not state or imply that the User endorses the Product,
                    and shall not publish quotes, results or case studies concerning the User without the
                    User's prior written consent. The User may withdraw this right at any time by written notice to Nave,
                    including by email to hello@getnave.com. Nave shall then stop using the User's company name and logo in new
                    materials without undue delay and remove them from its website within thirty (30) days. The same removal
                    applies upon termination of the Agreement.
                  </p>
                </div>

                <div>
                  <h2>XI. CONFIDENTIALITY OF USER CONTENT</h2>
                  <p>
                    <span>54.</span> Nave will not process User Content for any purpose other than the provision
                    of its Services and Product. The User retains all rights on the User Content and Nave will not
                    disclose such User Content to any third parties, except based on a disclosure request made in
                    accordance with the applicable legislation. Nave will take all necessary measures for protection
                    of User Content against any illegal access, disclosure, erasure, or alteration. In regard to
                    personal data contained within the User Content, Nave applies its{' '}
                    <a href="https://getnave.com/data-processing-agreement" target="_blank">
                      Data Processing Agreement
                    </a>
                    .
                  </p>
                </div>

                <div>
                  <h2>XII. WRITTEN FORM</h2>
                  <p>
                    <span>55.</span> The written form shall be considered as to have been complied with by the
                    sending of an IM message, a short text message (SMS), an e-mail, the click on a virtual button
                    on the Website, or the ticking of a check-box etc., as long as the statement has been
                    technically recorded in a way that enables it to be reproduced.
                  </p>
                </div>

                <div>
                  <h2>XIII. INVALIDITY</h2>
                  <p>
                    <span>56.</span> The parties hereby declare that in case any of the contractual clauses turn out
                    to be invalid, this shall not result in the Agreement, other clauses or parts thereof becoming
                    invalid. The invalid clause shall be replaced by the mandatory rules of the law or the
                    established practice.
                  </p>
                </div>

                <div>
                  <h2>XIV. APPLICABLE LAW</h2>
                  <p>
                    <span>57.</span> All the issues that are not regulated by the Agreement shall be governed by the
                    provisions of the applicable Bulgarian legislation.
                  </p>
                </div>

                <div>
                  <h2>XV. LEGAL DISPUTES' PROCEDURE</h2>
                  <p>
                    <span>58.</span> All the disputes arising from or related to the present Agreement, including
                    disputes caused by or linked to the interpretation, invalidity, non-fulfilment or termination of
                    the contractual relationships, shall be resolved by mutual agreement between Nave and the User.
                  </p>
                  <p>
                    <span>59.</span> Should the parties fail to reach an agreement, the dispute shall be referred to
                    the competent Bulgarian court for settlement.
                  </p>
                </div>

                <div className="scroll-top-button">
                  <a href="#terms-of-service" className="btn btn-secondary">
                    <ImageSize src={arrowUpIcon} alt="" />
                  </a>
                </div>

              </div>
            </Tab>
            <Tab eventKey='privacy' title="Privacy Policy">
              <div className="terms_scroll_content">
                <a name="privacy-policy"></a>
                <h1>PRIVACY POLICY</h1>
                <div className="terms_secondary-box">
                  <p>
                      Please, read carefully this Privacy Policy. It contains useful information on how Nave deals
                      with your personal data when you use Nave's Dashboards for Kanban Teams and Nave's website{' '}
                      <a target="_blank" href="https://getnave.com/">
                        https://getnave.com/
                      </a>
                      .
                  </p>
                  <p>
                      This Privacy Policy forms an integral part of Nave's{' '}
                      <a href="#" onClick={() => this.setState({ key: 'terms' })}>
                        Terms of Service
                      </a>
                      . If you do not agree with the Terms of Service or this Privacy Policy, please do not use the
                      Product.
                  </p>
                </div>
                <div>
                  <p>
                    <span>1.</span>In relation to the use of Nave's Dashboards for Kanban Teams ("the Product") and
                    Nave's website{' '}
                    <a target="_blank" href="https://getnave.com/">
                      https://getnave.com/
                    </a>{' '}
                    ("the Website"), Nave Ltd. ("Nave"/"We") collects and processes personal data related to natural
                    persons ("Data Subjects"/"You") in accordance with the terms of this Privacy Policy.
                  </p>

                  <p>
                    <span>2.</span> While processing personal data, Nave complies with all applicable data
                    protection legislative acts, including but not limited to Regulation (EU) 2016/679 on the
                    protection of natural persons with regard to the processing of personal data and on the free
                    movement of such data ('the Regulation').
                  </p>

                  <p>
                    <span>3.</span> According to the Regulation, Personal Data means any information relating to an
                    identified or identifiable natural person (e. g. name, e-mail address, etc.). Location data,
                    cookies and online identifiers such as IP addresses could also be considered Personal Data under
                    the Regulation. Processing of Personal Data ("Processing") means any operation or set of
                    operations which is performed with regard to the Personal Data such as collection, recording,
                    organization, structuring, storage, adaptation or alteration, retrieval, consultation, use,
                    disclosure by transmission, dissemination or otherwise making available, alignment or
                    combination, restriction, erasure or destruction.
                  </p>

                  <p>
                    <span>4.</span> Any capitalized term used but not defined in this Privacy Policy will have the
                    meaning defined in the Terms of Service and in the applicable legislation.
                  </p>
                </div>
                <div>
                  <h2>Categories of Data Subjects</h2>

                  <p>
                    <span>5.</span> In relation to the use of the Website or the Product, Nave may process Personal
                    Data of the following categories of Data Subjects:
                  </p>

                  <p className="second">
                    <span>a.</span> Natural persons - Users with a free trial or a paid subscription plan who have
                    signed up for the Product
                  </p>
                  <p className="second">
                    <span>b.</span> Natural persons - Platform users (active or not) on dashboards synced with the
                    Product
                  </p>
                  <p className="second">
                    <span>c.</span> Natural persons representing and acting on behalf of an entity - User of the
                    Product
                  </p>
                  <p className="second">
                    <span>d.</span> Visitors of the Website
                  </p>
                  <p className="second">
                    <span>e.</span> Natural persons, including such acting on behalf of an entity, who have provided
                    feedback, registered a complaint, submitted a request to Us, asked Us a question or have
                    addressed to or engaged in other type of correspondence with Us;
                  </p>
                  <p className="second">
                    <span>f.</span> Natural persons, including such acting on behalf of an entity, who are mentioned
                    in or are concerned by information contained in a query, complaint, requests or other
                    correspondence submitted to Us by another person.
                  </p>
                </div>
                <div>
                  <h2>Categories of Personal Data Processed by Nave</h2>
                  <p>
                    <span>6.</span> The information related to You which We may process according to the terms of
                    this Privacy Policy, may include:
                  </p>
                  <p className="second">
                    <span>a.</span> Data gathered from the platform
                  </p>
                  <p className="second">
                    <i>Setup of and login to the Product with the platform account</i>
                  </p>
                  <p className="second">
                    When You sign-up for the Product, You will be required to authenticate with Your platform login
                    credentials and authorize Us to access some of Your platform data (name, the platform username, email
                    address, Your platform boards and teams) which will allow Us to integrate and setup the Product
                    with Your platform account, as permitted by your platform profile settings. At the moment of the
                    authorization through the platform You provide Nave with the right to access the above mentioned
                    data in Your platform account. The categories of data which Nave may be authorized to access are
                    indicated in the authorization page. You are free to decide whether to authorize Nave's access
                    to Your platform account. However, please bear in mind that in case You deny Us access, You may
                    not be able to use the Product and take advantage of its features.
                  </p>
                  <p className="second">
                    Insofar as the Product fully integrates with Your platform account, every time when You wish to
                    access the Product through the Website You will need to authenticate using Your platform login
                    credentials. For avoidance of any doubt, We do not, under any circumstances, store or process
                    Your platform password. The latter is communicated directly to the platform. The platform then
                    informs Us on the successful authentication by sending Us an authorization token which allows Us
                    to log You in to the Product.
                  </p>
                  <p className="second">
                    <i>Use of the Product</i>
                  </p>
                  <p className="second">
                    The Product fully integrates with the platform: in order to generate cumulative flow diagrams,
                    cycle time scatterplots, throughput histograms, etc. related to Your platform projects it
                    accesses, syncs and displays information available within Your platform account as well as
                    information related to the use of platform features (boards, lists, cards, etc.). Depending on
                    the content of Your platform account and on Your platform usage, the information which We may
                    gather from the platform in order to provide You with the services within the Product, includes:
                  </p>
                  <div className="terms_table">
                    <table>
                      <tbody>
                        <tr>
                          <td>Data related to Users</td>
                          <td>User id; URL to user avatar; email address; full name; username</td>
                        </tr>
                        <tr>
                          <td>Data related to other platform users within dashboards synced with the Product</td>
                          <td>User id; URL to user avatar; full name</td>
                        </tr>
                        <tr>
                          <td>Boards data</td>
                          <td>
                            board id; name; organization id; short URL to the board; label names; preferences (board
                            background image, board background color)
                          </td>
                        </tr>
                        <tr>
                          <td>Organizations data</td>
                          <td>organization id; display name; memberships; URL to the logo; name</td>
                        </tr>
                        <tr>
                          <td>Lists data</td>
                          <td>list id; name; list position within the board; board id</td>
                        </tr>
                        <tr>
                          <td>Cards data</td>
                          <td>card id; name; board id; list id; labels id; members id; short URL to the card</td>
                        </tr>
                        <tr>
                          <td>Labels data</td>
                          <td>label id; name; color</td>
                        </tr>
                        <tr>
                          <td>Actions data</td>
                          <td>data related to changes to all typed of data above; date</td>
                        </tr>
                        </tbody>
                    </table>
                  </div>
                  <p className="second">
                    <span>b.</span> Data generated or gathered with relation to Your use of the Website or the
                    Product
                  </p>
                  <p className="second">
                    <i>Data gathered by Nave with relation to Your sign-up to the Product</i>
                  </p>
                  <p className="second">
                    When You sign-up for the Product and accept Our Terms of Service, We will keep and store
                    information proving for such acceptance (logs for date, time and source (IP address) of the
                    acceptance).
                  </p>
                  <p className="second">
                    <i>Data Generated with Relation to the Use of the Product</i>
                  </p>
                  <p className="second">
                    Any information contained in visualizations generated through the use of the Product is
                    processed by Nave in real time. The visualizations are made available in real time through
                    the Product website or through a generated URL for direct access to the Product graphs and
                    visualizations.
                  </p>
                  <p className="second">
                    <i>AI-Powered Analytics</i>
                  </p>
                  <p className="second">
                    The Product includes an optional AI-powered analytics feature that generates insights about workflow patterns. When this feature is enabled, anonymized workflow metrics — including cycle times, throughput, work-in-progress counts, and stage durations — are sent to our AI service providers (Anthropic and OpenAI) for analysis. Work item identifiers are hashed before transmission so that original item names are not shared with AI providers. No personally identifiable information, work item titles, or user names are sent. Our AI service providers process this data solely to generate the requested analysis and do not retain or use the data for model training.
                  </p>
                  <p className="second">
                    Nave stores the AI-generated analytics results (inputs and outputs) in Google Cloud Storage for service improvement and support purposes. This data is retained while the account is active and deleted when the account is deleted.
                  </p>
                  <p className="second">
                    <i>Data gathered with relation to the use of the Website and mobile devices</i>
                  </p>
                  <p className="second">
                    Like many sites on the Internet We may use third-party service providers (such as Google
                    Analytics, Mixpanel, Intercom, Wistia, etc.) that automatically collect certain information when You visit
                    the Website. This information may include Your IP address, Your browser type and language,
                    access times, the content of any undeleted cookies that Your browser previously accepted from Us
                    (see "Cookies" below) and referring/exit website address.
                  </p>
                  <p className="second">
                    In addition, in case You are using a mobile device, We may also use third-party service
                    providers that collect information through such devices about your device operating system,
                    browser type, IP address, referring/exit website address, device identifiers, etc. Your IP
                    address and/or country preference may thus be used in order to approximate Your location and
                    provide You with a better user experience.
                  </p>
                  <p className="second">
                    <span>c.</span> Financial information
                  </p>
                  <p className="second">
                    <i>Credit card details</i>
                  </p>
                  <p className="second">
                    In case You decide to sign-up for Our annual or monthly paid subscription plan upon expiration
                    of the free trial period or upon subscription within the said trial period, You will be required
                    to provide Your credit card details. These details are collected and processed by a third-party
                    service provider via secure payment processing services. For avoidance of any doubt, We do not
                    process or store credit card details ourselves.
                  </p>
                  <p className="second">
                    <i>Billing and payment information</i>
                  </p>
                  <p className="second">
                    We process certain payment and billing information related to You payments for Our annual or
                    monthly paid Product subscription for which You have signed-up. For example, We will need to
                    process the name of Your payment representative, billing address, amounts of payments due and of
                    overpayments, date and time of payments, overdue payments and unpaid invoices, information
                    contained in and related invoices and other financial and accounting documents, etc.
                  </p>
                  <p className="second">
                    The billing information which We may process is directly related to Your activity and use of the
                    platform and the Product. In order to assess and retrieve the amount of payments due and
                    possibly overpayments for the use of the Product We may need to process information regarding
                    the number of all active users and their activity throughout Your platform boards for the
                    respective billing period.
                  </p>
                  <p className="second">
                    <span>d.</span> Communications with You
                  </p>
                  <p className="second">
                    <i>Product-related announcements</i>
                  </p>
                  <p className="second">
                    We may use Your email address in order to send You Product-related announcements. These
                    announcements include our on-boarding communications with respect to the sign-up to the Product,
                    as well as Our email notifications for certain events related to Your sign-up and use of the
                    Product.
                  </p>
                  <p className="second">
                    We may also send You various communications with tips, tricks, ideas and good practices on how
                    to optimize the use of the Product in case and to the extend You have not unsubscribed to such
                    communications. With regard to such communications You are free to unsubscribe at any moment of
                    Your subscription for the Product.
                  </p>
                  <p className="second">
                    <i>Marketing communications</i>
                  </p>
                  <p className="second">
                    In an effort to update You with useful information regarding the newest products, services and
                    special offers provided by Nave, We may occasionally send You emails or newsletter
                    communications in case You have provided Us with Your explicit consent by subscribing to our
                    marketing and newsletter communications list. In case You subscribe for receiving such
                    communications from Us, We may process Your email address as well as logs for date, time and
                    source (IP address) proving for the subscription.
                  </p>
                  <p className="second">
                    If You do not wish to receive further such communications, You can, at any time, unsubscribe
                    from receiving them by clicking at the "Unsubscribe" link at the bottom of the e-mail or
                    newsletter.
                  </p>
                  <p className="second">
                    <i>Surveys</i>
                  </p>
                  <p className="second">
                    In case You have expressly opted in, from time to time We may invite You to participate in Our
                    surveys through which We aim to examine the opinion of Our users, customers and visitors of the
                    Website. For the purposes of such surveys, We might process the following information related to
                    You: email address, content of Your replies to the survey, as well as logs for date, time and
                    source (IP address) of Your acceptance to participate to the survey and sending of Your reply.
                  </p>
                  <p className="second">
                    <i>Feedback, requests, complaints and correspondence</i>
                  </p>
                  <p className="second">
                    If You contact Us to provide feedback, submit request, register a complaint, or ask a question,
                    including through the Website contact form, the Website online chat platform or via email, We
                    will process the Personal Data and the other content which You provide in Your communication to
                    Us so that We can effectively respond to Your request, complain or other communication. We will
                    also process information on the status of Your feedback, request, complaint or other
                    communication and the result from its processing by Us. Additionally, We may process Your
                    Personal Data in case it is contained in feedbacks, requests, complaints, questions or other
                    queries, submitted to Us by another person. In these instances, We will process Personal Data
                    related to You solely to the extent needed for the purposes of replying to or taking action with
                    regard to the respective feedback, request, complaint, question or query.
                  </p>
                  <p className="second">
                    <span>e.</span> Cookies
                  </p>
                  <p className="second">
                    <i>What are cookies?</i>
                  </p>
                  <p className="second">
                    Cookies are small text files that are placed on Your device (computer/smartphone/tablet) by
                    websites that You visit. They are widely used in order to make websites work, to improve the
                    user experience, as well as to provide information to the owners of the website about its
                    traffic and usage. Cookies may be "session" or "persistent". "Session" cookies are stored on
                    Your device until You leave the Website. Persistent cookies remain on Your device for a
                    pre-defined period of time.
                  </p>
                  <p className="second">
                    <i>Why do We use cookies?</i>
                  </p>
                  <p className="second">
                    Nave uses cookies to facilitate access to and the performance of the Website, to personalize and
                    improve Your user experience as well as to monitor aggregate usage and web traffic routing on
                    the Website.
                  </p>
                  <p className="second">
                    <i>What types of cookies do We use?</i>
                  </p>
                  <div className="terms_table">
                    <table>
                      <thead>
                        <tr>
                          <th>Type of cookies</th>
                          <th>Description</th>
                          <th>Storage period</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Functional cookies</td>
                          <td>
                            Functional cookies are cookies which are essential for the Website to work. For example, a
                            "session" cookie which helps You navigate from one webpage to another through the Website is
                            a functional cookie.
                          </td>
                          <td>60000 sec</td>
                        </tr>
                        <tr>
                          <td>Non-functional cookies</td>
                          <td>
                            Non-functional cookies are cookies which are not essential for the Website to work. For
                            example, a cookie that helps the Website recognize You when You revisit it at a later point
                            without a need for You to login again, is a non-functional cookie.
                          </td>
                          <td>60000 sec </td>
                        </tr>
                        <tr>
                          <td>Third-party cookies</td>
                          <td>
                            Third-party cookies are generally used for traffic analysis and personalized ads. You can
                            refuse and/or delete them by rejecting them, when asked at the beginning of Your visit of
                            the Website, by using the settings of Your web browser or by visiting the website of the
                            respective provider and following the instructions thereon. For more information on
                            third-party cookies which may be used throughout the Website and the Product, please, visit
                            the following web pages:
                            &nbsp;<a href="https://policies.google.com/privacy" target="_blank">
                              Google Analytics
                            </a>
                            ,
                            &nbsp;<a href="https://www.intercom.com/legal/privacy" target="_blank">
                              Intercom
                            </a>
                            ,
                            &nbsp;<a href="https://mixpanel.com/legal/privacy-policy/" target="_blank">
                              Mixpanel
                            </a>
                            ,
                            &nbsp;<a href="https://wistia.com/privacy" target="_blank">
                              Wistia
                            </a>
                            ,
                            &nbsp;<a href="https://www.deadlinefunnel.com/privacy" target="_blank">
                              Deadline Funnel
                            </a>
                            .
                          </td>
                          <td>NA</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="second">
                    <i>Control over the cookies</i>
                  </p>
                  <p className="second">
                    As far as functional cookies are strictly necessary for the Website to work, You cannot refuse
                    or limit their use. By using the Website, You confirm that You are informed on the use and
                    storage of such cookies on Your device.
                  </p>
                  <p className="second">
                    Non-functional cookies are not strictly necessary for the Website to work correctly. You can
                    reject their use at the beginning of the visit of the Website. In addition, You can modify the
                    settings of Your web browser or delete accepted cookies at any time. For further instructions,
                    please visit the websites of the most popular browsers:
                    &nbsp;<a href="https://support.microsoft.com/en-us/microsoft-edge" target="_blank">
                      Microsoft Edge
                    </a>
                    ,
                    &nbsp;<a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank">
                      Chrome
                    </a>
                    ,
                    &nbsp;<a
                      href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer?redirectlocale=en-US&redirectslug=Cookies"
                      target="_blank"
                    >
                      Firefox
                    </a>
                    ,
                    &nbsp;<a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank">
                      Safari
                    </a>
                    ,
                    &nbsp;<a href="https://help.opera.com/en/latest/" target="_blank">
                      Opera
                    </a>
                    ,
                    &nbsp;<a href="https://support.apple.com/en-us/HT201265" target="_blank">
                      iOS
                    </a>
                    .
                  </p>

                  <p className="second">
                    As for third-party cookies, You can refuse and/or delete them by rejecting them, when asked at
                    the beginning of Your visit of the Website, by using the settings of Your web browser, as
                    explained on the respective web browser's page quoted above, or by visiting the website of the
                    respective provider and following the instructions thereon. For more information on third-party
                    cookies which may be used throughout the Website and the Product, please visit the
                    following web pages: <a href="https://policies.google.com/privacy" target="_blank">Google Analytics</a>, <a href="https://www.intercom.com/legal/privacy" target="_blank">Intercom</a>, <a href="https://mixpanel.com/legal/privacy-policy/" target="_blank">Mixpanel</a>, <a href="https://wistia.com/privacy" target="_blank">Wistia</a>, <a href="https://www.deadlinefunnel.com/privacy" target="_blank">Deadline Funnel</a>.
                  </p>
                  <p className="second">
                    If You have any questions about the use of cookies, You can contact Us at <a href="mailto:hello@getnave.com">hello@getnave.com</a>.
                  </p>

                  <p className="second">
                    <span>F.</span> Do Not Track signals
                  </p>
                  <p className="second">
                    Nave does not respond to Do Not Track signals from browsers. A number of browsers allow users to send such preferences,
                    however the Product and the Website do not change their data collection practices when a Do Not Track signal is received.
                  </p>
                </div>

                <div>
                  <h2>How Do We process Your Personal Data?</h2>
                  <p>
                    <span>7.</span> We may collect, use, and process some or all of the categories of Personal Data
                    as described under item 6 above for the purposes provided for in this Privacy Policy. Depending
                    on the legal basis of the processing, these purposes may include:
                  </p>
                  <p className="second">
                    <span>a.</span> Purposes necessary for the conclusion and performance of the contract concluded
                    between You and Nave under the Terms of Service with regard to the use of the Product
                  </p>
                  <ul className="list_bulet third">
                    <li>
                      Delivering You the services which You have requested with regard to Your use of the Product,
                      incl. setting up Your use of the Product, authenticating You, operating and maintaining the
                      Product, etc.;
                    </li>
                    <li>Processing payments with relation to Your use of the Product;</li>
                    <li>Providing You with customer support;</li>
                    <li>Enforcing or exercising the rights under Our Terms of Service;</li>
                    <li>
                      Communicating with You, including by email with relation to Your use of the Product in
                      accordance with Our Terms of Service and/or for notifying You of changes in the services which
                      We provide and their terms.
                    </li>
                  </ul>
                  <p className="second">
                    <span>b.</span> Purposes necessary for protecting and exercising the legitimate interests of
                    Nave and third parties
                  </p>
                  <ul className="list_bulet third">
                    <li>
                      Ensuring the Website and the Product's normal functioning and use by You, incl. by sending You
                      information about updates of the Product;
                    </li>
                    <li>
                      Maintaining and administrating the Website and the Product in accordance with Our Terms of
                      Service;
                    </li>
                    <li>
                      Updating and improving the functionality and the features of the Website, and the Product, as
                      well as Our features for communicating with You;
                    </li>
                    <li>Detecting and preventing malicious activities;</li>
                    <li>Detecting and repairing technical or functionality related issues;</li>
                    <li>Ensuring business organization and planning;</li>
                    <li>
                      Communicating with You, including by email, with respect to certain important matters related
                      to the Website and the Product;
                    </li>
                    <li>
                      Exercising and protecting Our rights and legal interests, including by legal proceedings, and
                      rendering assistance to other users of the Website and the Product, and/or affected third
                      persons in exercising and protecting their rights and legal interests;
                    </li>
                    <li>Establishing, exercising or defending legal claims.</li>
                  </ul>
                  <p className="second">
                    <span>c.</span> Purposes related to fulfilment of Nave's legal obligations
                  </p>
                  <ul className="list_bulet third">
                    <li>
                      Performing activities related to statutory obligations for the retention or provision of
                      information upon receipt of a relevant order issued by competent state or court authorities;
                    </li>
                    <li>
                      Fulfilling legal obligations with regard to accounting, tax, financial and invoice activities
                    </li>
                    <li>
                      Fulfilling statutory obligations to provide assistance to competent state authorities when
                      exercising their control powers;
                    </li>
                    <li>
                      Fulfilling legal obligations to notify You of various circumstances related to the Website,
                      the Product or other services provided to You, the processing activities carried out in this
                      relation and Your rights under the data protection regulation;
                    </li>
                    <li>
                      Documenting and reporting of activities and fulfilling other obligations related to the
                      requirements of GDPR and other applicable legislation.
                    </li>
                  </ul>
                  <p className="second">
                    <span>d.</span> Purposes related to Your explicit consent provided to Nave
                  </p>
                  <p className="second">
                    Processing of data for either of the below purposes may be conducted only in cases where You
                    have provided Nave with Your separate explicit consent and solely within the scope and to the
                    extent provided for by the respective consent. Accepting Our Terms of Service does not equal
                    granting Us Your consent and would not justify or be sufficient for conducting data processing
                    activities based on consent. When We process Personal Data on the basis of consent, We will
                    clearly ask for Your separate and explicit such consent. The purposes for which We might do so,
                    include:
                  </p>
                  <ul className="list_bulet third">
                    <li>Using Your email address to send You marketing communications and newsletters.</li>
                    <li>
                      Inviting You to participate in Our surveys through which We may examine Your opinion of the
                      Website and the Product, and processing the data gathered with respect to Your participation
                      to such survey.
                    </li>
                  </ul>
                </div>
                <div>
                  <h2>How Long We Store Information About You?</h2>
                  <p>
                    <span>8.</span> Nave applies the principle of storing data in minimal volume and for a period
                    not longer than the strictly necessary to the purposes for which data were collected, ensuring
                    that data are stored securely and in compliance with the applicable legislation.
                  </p>
                  <p>We store the enlisted types of data for the following period:</p>
                  <div className="terms_table">
                    <table>
                      <thead>
                        <tr>
                          <th>Type of data</th>
                          <th colSpan="2">Storage period</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Data contained in documents related to payments, invoices, accounting documents</td>
                          <td colSpan="2">
                            10 (ten) years, counting from the beginning of the year following the one during which the
                            payment is due
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Data created with regard to Your subscription (free trial or paid) for and use of the
                            Product, except for data related to payments, invoices, accounting and other financial
                            activities
                          </td>
                          <td colSpan="2">
                            For the entire period Your subscription is active and maintained by Us and up to 3 (three)
                            months following the expiration of the Product's trial period or the termination of Your
                            paid subscription
                          </td>
                        </tr>
                        <tr>
                          <td rowSpan="4">Logs</td>
                          <td>
                            For date and time, and for source (IP address) of actions undertaken by You with regard to
                            Our contractual relations (subscription, payments, acceptance of Terms of Service, etc.)
                          </td>
                          <td>
                            For the entire period Your subscription is active and maintained by Us and up to 3 (three)
                            months following the expiration of the Product's trial period or the termination of Your
                            paid subscription
                          </td>
                        </tr>
                        <tr>
                          <td>
                            For date and time, and for source (IP address) of actions with regard to providing/
                            withdrawing consent
                          </td>
                          <td>
                            Until the consent is withdrawn and for a reasonable period of time following the
                            "Unsubscribe" request, necessary to the processing of the request.
                          </td>
                        </tr>
                        <tr>
                          <td>For login/authentication to the Product</td>
                          <td>3 (three) months counting from the last login</td>
                        </tr>
                        <tr>
                          <td>Server and system</td>
                          <td>3 (three) months</td>
                        </tr>
                        <tr>
                          <td>Correspondence, incl. but not limited to feedback, requests, complaints and claims</td>
                          <td colSpan="2">
                            In case the correspondence is carried out with a subscriber of the Product – for the entire
                            period the respective subscription is active and is maintained by Us and up to 5 (five)
                            years following the termination of the subscription.
                            <br />
                            For correspondence carried out with other persons – for a period of 5 (five) years following
                            the last action undertaken as a result of the respective correspondence.
                          </td>
                        </tr>
                        <tr>
                          <td>Data processed on the grounds of Your explicit consent provided to Nave</td>
                          <td colSpan="2">
                            Until the consent is withdrawn and for a reasonable period of time following the
                            "Unsubscribe" request, necessary to the processing of the request.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    In case of a legal dispute or proceedings requiring data retention and/or in case of a request
                    of a competent state authority, data may be stored for longer periods than the ones specified
                    above, until the final settlement of the dispute or proceedings before all instances. Data
                    storage periods may also be changed according to the requirements of applicable legislation.
                  </p>
                </div>
                <div>
                  <h2>Do We Share Information About You With Third Parties?</h2>
                  <p>
                    <span>9.</span> Nave will not provide or disclose Your Personal Data to third parties in any way
                    other than those set out in this Privacy Policy and the Terms of Service.
                  </p>
                  <p className="second">
                    <span>a.</span> Data processors
                  </p>
                  <p className="second">
                    Nave may engage subcontractors and service providers to perform task on behalf of Nave – data
                    processors, such as dedicated data centers for reliable and secure colocation of servers and
                    network equipment, providers of accounting services, developers, providers of marketing
                    assistance, etc. When engaging such processors, We require that they access and process Personal
                    Data solely on behalf of Nave and to the extent strictly necessary to the performance of their
                    tasks assigned by Nave. All such subcontractors and service providers are contractually obliged
                    to strictly comply with Nave's documented instructions and are prohibited from using the
                    Personal Data for other purposes.
                  </p>
                  <p className="second">
                    <span>b.</span> Other data controllers
                  </p>
                  <p className="second">
                    In certain cases, Nave may share Your Personal Data with its business partners and contractors –
                    other data controllers, such as third-party financial transaction facilitators, (Stripe,
                    PayPal), web traffic analysis service providers (Google Analytics, Mixpanel, Intercom), video hosting providers (Wistia), marketing tools (Deadline Funnel), etc. When We
                    work with other data controllers, We adequately settle the rights and obligations of both
                    parties with regard to the processing of personal data (incl. the prohibition of using Personal
                    Data for purposes other than those related to the fulfillment of the respective party's tasks),
                    by concluding specific Data Processing Agreements with them.
                  </p>
                  <p className="second">
                    <span>c.</span> Other instances
                  </p>
                  <p className="second">We may also disclose Your Personal Data to third parties:</p>
                  <ul className="list_bulet third">
                    <li>when this is prescribed for by law; </li>
                    <li>if requested by a competent state, municipal or judicial authority; or</li>
                    <li>
                      when it is necessary to the exercise and protection of Our rights and legal interests,
                      including when seeking professional advice, engaging into legal proceedings, etc.;
                    </li>
                    <li>with Your explicit consent.</li>
                  </ul>
                  <p className="second"></p>
                  <p className="second"></p>
                  <p className="second"></p>
                  <p className="second"></p>
                </div>
                <div>
                  <h2>Your Rights with Relation to Your Personal Data Processed by Nave</h2>
                  <p>
                    <span>10.</span> With respect to the processing of Your Personal Data for the purposes described
                    in this Privacy Policy, You have the following rights:
                  </p>
                  <div className="terms_table">
                    <table>
                    <tbody>
                      <tr>
                        <td>Right of information</td>
                        <td>
                          You have the right to obtain information on the processing of Your personal data. This
                          Privacy Policy aims to inform You in detail on the processing of Your Personal Data by Nave
                        </td>
                      </tr>
                      <tr>
                        <td>Right of access</td>
                        <td>
                          You are entitled to receive confirmation whether Your Personal Data is being processed, to
                          receive access to it, as well as to obtain information about the processing and Your rights.
                        </td>
                      </tr>
                      <tr>
                        <td>Right of rectification</td>
                        <td>
                          You are entitled to have Your Personal Data rectified in case it is incomplete or
                          inaccurate. Your data may be rectified by Us upon a request from Your side. Please note that
                          We cannot rectify Personal Data which You have authorized Us to gather from the platform.
                          Such data may be rectified solely throught the platform. For more information on how this
                          may be done, please refer to the platform's Terms of service and privacy documents.
                          <br />
                          In addition, You can modify certain of Your Personal Data (credit card number, billing name
                          and address) collected and processed by third-party service providers for secure payment
                          services by re-entering it in the respective form.
                        </td>
                      </tr>
                      <tr>
                        <td>Right of erasure</td>
                        <td>
                          You have the right to request for Your Personal Data to be erased unless there is a legal
                          ground and/or legal obligation for their processing. When exercising this right, please keep
                          in mind that certain data is required for the correct functioning of the Website/the
                          Product.
                        </td>
                      </tr>
                      <tr>
                        <td>Right of restriction of the processing</td>
                        <td>
                          You have the right to make a request for restricting the processing of Your Personal Data in
                          case there are grounds for this provided by the applicable legislation.
                        </td>
                      </tr>
                      <tr>
                        <td>Right to notify third parties</td>
                        <td>
                          Where applicable, You have the right to request from Nave to notify third parties on the
                          rectification, erasure or restriction of the processing of Your Personal Data in case Nave
                          has provided Your data to such third parties.
                        </td>
                      </tr>
                      <tr>
                        <td>Right of data portability</td>
                        <td>
                          You have the right to receive the Personal Data related to You which You have provided to
                          Nave, in a structured, commonly used, machine-readable format, and to provide these data to
                          another data controller. Where technically feasible, You can request Nave to directly
                          provide Your Personal Data to another data controller.
                        </td>
                      </tr>
                      <tr>
                        <td>Right not to be subject to a decision based solely on automated processing</td>
                        <td>
                          You have the right not to be subject to a decision based solely on automated processing,
                          including profiling which produces legal effects concerning or significantly affecting You
                          unless there are grounds provided for by the applicable data protection legislation, as well
                          as appropriate safeguards to protect Your rights, freedoms and legitimate interests.
                        </td>
                      </tr>
                      <tr>
                        <td>Right to withdraw Your consent</td>
                        <td>
                          In case You have provided Us with Your prior consent for processing of Your Personal Data,
                          You have the right to withdraw this consent at any time. Such withdrawal shall not affect
                          the lawfulness of the processing based on consent before its withdrawal. For instance, You
                          can unsubscribe from receiving marketing communications and newsletters by clicking at the
                          "Unsubscribe" link at the bottom of the e-mail or newsletter.
                        </td>
                      </tr>
                      <tr>
                        <td>Right to object to the processing</td>
                        <td>
                          You have the right, at any time and on grounds related to the specific case, to object to
                          the processing of Your Personal Data processed on the basis of legitimate interest. In the
                          event of such an objection We will examine Your request and, if justified, We will comply
                          with it. If We believe there are sufficient legal grounds for the processing or the
                          processing is necessary for establishing, exercising or defending legal claims, We will
                          inform You accordingly.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    <i>Exercise Your rights</i>
                  </p>
                  <p>
                    <span>11.</span> You can exercise the above rights at any time by sending Us a message via the
                    contact form available in the "Contact" section of the Website or an email at  <a href="mailto:hello@getnave.com">hello@getnave.com</a>.
                  </p>
                  <p>
                    <i>Right to lodge a complaint with a supervisory authority</i>
                  </p>
                  <p>
                    <span>12.</span> You have the right to lodge a complaint with a supervisory authority if You
                    consider that the processing of Your Personal Data infringes on the applicable data protection
                    legislation. The supervisory authority in the Republic of Bulgaria is the Commission of Personal
                    Data Protection, with address: 2 Prof. Tsvetan Lazarov Blvd., Sofia 1592.
                  </p>
                </div>
                <div>
                  <h2>Children's Privacy</h2>
                  <p>
                    The Website and the Product are not directed to children under 13. Nave does not knowingly collect personal information from children under
                    13 and the service is not designed for their use. If we become aware that personal information has been collected from a child under 13,
                    we will delete that information without delay. If you believe that such information may have been submitted to us,
                    please contact us at <a href="mailto:hello@getnave.com">hello@getnave.com</a>.
                  </p>
                </div>
                <div>
                  <h2>About Nave</h2>
                  <p>
                    <span>13.</span> Nave Ltd. is a company duly registered and existing under the laws of the
                    Republic of Bulgaria, with company number 202979859 and seat and registered address in Bulgaria,
                    1336 Sofia, Lyulin Residential District, building 384, entry A, floor 7, ap. 20.
                  </p>

                  <p>
                    <span>14.</span> In case You have any questions or queries with regard to the processing of Your
                    personal data by Nave, please contact Us at +32 (0) 470 998915 or email Us at: <a href="mailto:hello@getnave.com">hello@getnave.com</a> and We will be happy to assist or provide You with further information.
                  </p>

                  <br />
                  <p>Last update: February 13, 2026</p>
                </div>

                <div className="scroll-top-button">
                  <a href="#privacy-policy" className="btn btn-secondary"> 
                    <ImageSize src={arrowUpIcon} alt="" />
                  </a> 
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>

          <div className="terms_actions">
            <div className="terms_actions_content">
              <Button onClick={this.agree} variant='primary'>
                I agree to the Terms of Service and Privacy Policy
              </Button>
              {this.props.outside ? (
                <Button
                  onClick={() => {
                    this.decline();
                    window.close();
                  }}
                  variant='secondary'
                >
                  I do not agree
                </Button>
              ) : (
                <Button onClick={this.decline} variant='secondary'>
                  I do not agree
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    outside: state.app.outside
  };
}

export default withRouter(connect(mapStateToProps)(Terms));
